(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sa-axis-bundle-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sa-axis-bundle-offer')) {
  customElements.define('sa-axis-bundle-offer', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.initialized) return;
        const source = this.querySelector('[data-sa-bundle-config]');
        this.form = this.closest('form');
        this.root = this.closest('.sap-sections');
        if (!source || !this.form) return;
        try { this.config = JSON.parse(source.textContent); } catch { return; }
        this.initialized = true;
        this.dataset.saBundleReady = 'true';
        this.listeners = new AbortController();
        const options = {signal: this.listeners.signal};
        this.querySelectorAll('[data-sa-bundle-size], .sa-bundle__choice').forEach(control => { control.disabled = false; });
        this.addEventListener('change', event => {
          if (this.busy) return;
          const offer = event.target.closest('[data-sa-bundle-offer]');
          if (offer && event.target.matches('[data-sa-bundle-size]')) offer.querySelector('.sa-bundle__choice').checked = true;
          this.sync();
          this.refreshProduct();
        }, options);
        this.form.addEventListener('submit', event => this.submit(event), {...options, capture: true});
        window.addEventListener('pageshow', event => {
          if (event.persisted) this.restoreForm();
        }, options);
        this.sync();
        this.refreshProduct();
      });
    }

    disconnectedCallback() {
      this.listeners?.abort();
      this.request?.abort();
      this.restoreForm();
      this.initialized = false;
      delete this.dataset.saBundleReady;
    }

    quantity() { return this.querySelector('input[name="quantity"]:checked')?.value === '2' ? 2 : 1; }

    variantFor(role) {
      const id = this.querySelector('[data-sa-bundle-size="' + role + '"]')?.value || this.config.selectedVariant;
      return this.config.variants.find(variant => String(variant.id) === String(id));
    }

    pillows() { return this.quantity() === 2 ? [this.variantFor('first'), this.variantFor('second')] : [this.variantFor('single')]; }

    covers() {
      if (!this.config.cover) return {items: [], matched: false};
      const normalize = value => String(value || '').trim().toLocaleLowerCase();
      const variants = this.config.cover.variants;
      const matched = this.pillows().map(pillow => variants.find(cover => normalize(cover.size) === normalize(pillow?.size)));
      if (matched.every(Boolean)) return {items: matched, matched: true};
      const selected = this.querySelector('[data-sa-bundle-cover-variant]')?.value || this.config.cover.selectedVariant;
      const cover = variants.find(variant => String(variant.id) === String(selected)) || variants[0];
      return {items: this.pillows().map(() => cover), matched: variants.length === 1};
    }

    write(selector, text, visible) {
      const node = this.querySelector(selector);
      if (!node) return;
      node.textContent = text || '';
      if (typeof visible === 'boolean') node.hidden = !visible;
    }

    sync() {
      if (!this.initialized) return;
      const single = this.variantFor('single');
      const first = this.variantFor('first'), second = this.variantFor('second');
      const pair = this.config.pairs.find(item => String(item.first) === String(first?.id) && String(item.second) === String(second?.id));
      if (single) {
        this.write('[data-sa-bundle-single-price]', single.singlePrice);
        this.write('[data-sa-bundle-single-compare]', single.singleCompare, single.hasCompare);
        this.write('[data-sa-bundle-single-savings]', single.savings, single.hasCompare);
      }
      if (pair) {
        this.write('[data-sa-bundle-pair-price]', pair.price);
        this.write('[data-sa-bundle-pair-compare]', pair.compare, pair.hasCompare);
        this.write('[data-sa-bundle-pair-savings]', pair.savings, pair.hasCompare);
      }
      const pillows = this.pillows();
      const hiddenId = this.form.querySelector('[data-variant-id]');
      if (hiddenId && pillows[0]) hiddenId.value = pillows[0].id;
      const coverSelection = this.covers();
      const checkbox = this.querySelector('[data-sa-bundle-cover-toggle]');
      if (checkbox) {
        const available = coverSelection.items.length === pillows.length && coverSelection.items.every(cover => cover?.available);
        checkbox.disabled = this.busy || !available;
        if (!available) checkbox.checked = false;
        const options = this.querySelector('[data-sa-bundle-cover-options]');
        if (options) options.hidden = coverSelection.matched;
        let prices = coverSelection.items[0];
        if (coverSelection.items.length === 2) prices = this.config.cover.pairs.find(item => String(item.first) === String(coverSelection.items[0]?.id) && String(item.second) === String(coverSelection.items[1]?.id));
        if (prices) {
          this.write('[data-sa-bundle-cover-price]', prices.price);
          this.write('[data-sa-bundle-cover-compare]', prices.compare, prices.hasCompare);
        }
        this.write('[data-sa-bundle-cover-quantity]', pillows.length === 2 ? this.config.strings.twoCovers : this.config.strings.oneCover);
        this.write('[data-sa-bundle-cover-status]', available ? '' : this.config.strings.soldOut);
        const coverNote = coverSelection.matched ? this.config.strings.matchedCoverNote : this.config.strings.coverNote;
        this.write('[data-sa-bundle-cover-note]', pillows.length === 2 && !this.config.coverPairDiscountShown ? coverNote + ' ' + this.config.strings.coverMarketNote : coverNote);
        const picture = this.querySelector('[data-sa-bundle-cover-image]');
        if (picture && coverSelection.items[0]?.image) picture.src = coverSelection.items[0].image;
      }
      const available = pillows.length === this.quantity() && pillows.every(pillow => pillow?.available);
      this.form.querySelectorAll('[data-submit]').forEach(button => { button.disabled = this.busy || !available; });
      this.form.querySelectorAll('[data-submit-label]').forEach(label => { label.textContent = this.busy ? this.config.strings.adding : available ? this.config.strings.cart : this.config.strings.soldOut; });
      if (!this.busy) this.querySelector('[data-sa-bundle-error]').hidden = true;
    }

    refreshProduct() {
      window.saProductSections?.refresh();
      this.sync();
    }

    showError(message) {
      const error = this.querySelector('[data-sa-bundle-error]');
      error.textContent = message;
      error.hidden = false;
      error.focus({preventScroll: true});
    }

    restoreForm() {
      if (!this.formState) return;
      this.formState.forEach(({control, disabled}) => { control.disabled = disabled; });
      this.formState = null;
      this.form?.removeAttribute('aria-busy');
      this.busy = false;
      if (this.initialized && this.isConnected) this.sync();
    }

    async submit(event) {
      const coverChecked = this.querySelector('[data-sa-bundle-cover-toggle]')?.checked;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      const selected = this.pillows().concat(coverChecked ? this.covers().items : []);
      if (selected.some(item => !item?.available)) {
        this.showError(this.config.strings.unavailable);
        return;
      }
      const grouped = new Map();
      selected.forEach(item => {
        const key = String(item.id);
        const existing = grouped.get(key);
        if (existing) existing.quantity += 1;
        else grouped.set(key, {id: item.id, quantity: 1});
      });
      this.busy = true;
      this.formState = Array.from(this.form.elements).filter(control => 'disabled' in control).map(control => ({control, disabled: control.disabled}));
      this.formState.forEach(({control}) => { control.disabled = true; });
      this.form.setAttribute('aria-busy', 'true');
      this.form.querySelectorAll('[data-submit-label]').forEach(label => { label.textContent = this.config.strings.adding; });
      this.querySelector('[data-sa-bundle-error]').hidden = true;
      this.request = new AbortController();
      try {
        const url = this.config.routes.add.endsWith('.js') ? this.config.routes.add : this.config.routes.add + '.js';
        const response = await fetch(url, {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [...grouped.values()]}),
          signal: this.request.signal
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          this.restoreForm();
          this.showError(typeof result.description === 'string' ? result.description : this.config.strings.error);
          return;
        }
        this.restoreForm();
        if (window.saCartDrawer) window.saCartDrawer.open(this.config.routes.cart);
        else window.location.assign(this.config.routes.cart);
      } catch (error) {
        this.restoreForm();
        if (this.isConnected && error.name !== 'AbortError') this.showError(this.config.strings.error);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sa-cart-shipping"] && !Shopify.designMode) return;
  try {
    (() => {
    const headerSelector = '[data-essential-cart-element="cart-drawer-header"]';
    let scheduled = false;
    const mount = () => {
      scheduled = false;
      const template = document.getElementById('sa-cart-shipping-template');
      if (!template) return;
      document.querySelectorAll(headerSelector).forEach((header) => {
        if (header.parentElement.querySelector('[data-sa-cart-shipping]')) return;
        header.after(template.content.firstElementChild.cloneNode(true));
      });
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(mount);
    };
    const relevant = (node) => node.nodeType === 1 && (
      node.matches(headerSelector) || node.matches('[data-sa-cart-shipping]') || node.querySelector(headerSelector)
    );
    new MutationObserver((records) => {
      if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some(relevant))) schedule();
    }).observe(document.body, {childList: true, subtree: true});
    document.addEventListener('essential-cart:open', schedule);
    document.addEventListener('essential-cart:update', schedule);
    mount();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sa-product-section"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.saProductSections) { window.saProductSections.refresh(); return; }
  const controllers = new Map();
  class ProductSections {
    constructor(root) {
      this.root = root;
      this.pending = false;
      this.width = root.clientWidth;
      this.observer = new ResizeObserver(entries => {
        if (entries.some(entry => entry.target !== root || root.clientWidth !== this.width)) this.schedule();
        this.width = root.clientWidth;
      });
      this.observer.observe(root);
      this.thumbnailStart = 0;
      this.click = event => {
        const opener = event.target.closest('[data-size-guide-open]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.sizeGuideOpen);
          if (dialog && !dialog.open) dialog.showModal();
        }
        const close = event.target.closest('[data-size-guide-close]');
        if (close) close.closest('dialog').close();
        if (event.target.matches('.sap__size-dialog')) event.target.close();
        const button = event.target.closest('[data-media-target]');
        const arrow = event.target.closest('[data-media-step]');
        if (button) this.showMedia(button.dataset.mediaTarget);
        if (arrow) this.stepMedia(Number(arrow.dataset.mediaStep));
        const reviewArrow = event.target.closest('[data-review-step]');
        if (reviewArrow) this.stepReview(reviewArrow.closest('[data-review-carousel]'), Number(reviewArrow.dataset.reviewStep));
      };
      this.keydown = event => {
        const button = event.target.closest('[data-media-target]');
        if (!button || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const buttons = [...this.root.querySelectorAll('[data-media-target]')];
        const index = buttons.indexOf(button);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : Math.max(0, Math.min(buttons.length - 1, index + (event.key === 'ArrowRight' ? 1 : -1)));
        event.preventDefault();
        this.showMedia(buttons[next].dataset.mediaTarget);
        buttons[next].focus();
      };
      this.change = event => { if (event.target.matches('[data-option]')) this.update(true); };
      root.addEventListener('click', this.click);
      root.addEventListener('change', this.change);
      root.addEventListener('keydown', this.keydown);
      this.pointerdown = event => {
        this.swipe = event.pointerType === 'touch' && event.target.closest('.sap__hero-image') ? {x:event.clientX,y:event.clientY} : null;
      };
      this.pointerup = event => {
        if (!this.swipe) return;
        const dx = event.clientX - this.swipe.x, dy = event.clientY - this.swipe.y;
        this.swipe = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.stepMedia(dx < 0 ? 1 : -1);
      };
      this.pointercancel = () => { this.swipe = null; };
      root.addEventListener('pointerdown', this.pointerdown);
      root.addEventListener('pointerup', this.pointerup);
      root.addEventListener('pointercancel', this.pointercancel);
      this.blockselect = event => {
        const slide = event.target.closest('[data-review-slide]');
        if (slide && root.contains(slide)) {
          const carousel = slide.closest('[data-review-carousel]');
          this.showReview(carousel, [...carousel.querySelectorAll('[data-review-slide]')].indexOf(slide));
        }
      };
      root.addEventListener('shopify:block:select', this.blockselect);
      this.refresh();
    }
    refresh() {
      const config = this.root.querySelector('[data-product-config]');
      this.config = config ? JSON.parse(config.textContent) : null;
      const sizeDialog = this.root.querySelector('[data-sa-part="variant_picker"] .sap__size-dialog');
      const bundleSizeLinks = [...this.root.querySelectorAll('[data-sa-bundle-size-guide]')];
      bundleSizeLinks.forEach(link => {
        link.hidden = !sizeDialog;
        if (sizeDialog) {
          link.dataset.sizeGuideOpen = sizeDialog.id;
          link.setAttribute('aria-controls', sizeDialog.id);
        } else {
          delete link.dataset.sizeGuideOpen;
          link.removeAttribute('aria-controls');
        }
      });
      this.root.querySelectorAll('[data-sa-part="variant_picker"]').forEach(picker => {
        picker.toggleAttribute('data-sa-size-in-bundle', Boolean(sizeDialog && bundleSizeLinks.length && picker.contains(sizeDialog)));
      });
      this.observer.disconnect();
      this.observer.observe(this.root);
      this.sections().forEach(section => this.observer.observe(section));
      this.update(false);
      const selected = this.root.querySelector('[data-media-target][aria-pressed="true"]');
      if (selected) this.showMedia(selected.dataset.mediaTarget);
      else this.showThumbnails(this.thumbnailStart);
      this.schedule();
    }
    sections() { return [...this.root.children].filter(node => node.classList.contains('shopify-section')); }
    schedule() {
      if (this.pending) return;
      this.pending = true;
      requestAnimationFrame(() => { this.pending = false; if (this.root.isConnected) this.layout(); });
    }
    layout() {
      const root = this.root, sections = this.sections();
      root.style.setProperty('--sa-screen-width', document.documentElement.clientWidth + 'px');
      this.showThumbnails(this.thumbnailStart);
      root.style.height = '';
      sections.forEach(section => ['width','left','top','height'].forEach(property => section.style[property] = ''));
      if (window.innerWidth < 750) {
        delete root.dataset.saLayout;
        sections.forEach(section => { section.style.gridColumn = ''; section.style.gridRow = ''; });
        return;
      }
      root.dataset.saLayout = 'grid';
      let leftRow = 1, rightRow = 1;
      sections.forEach(section => {
        if (getComputedStyle(section).display === 'none') return;
        const column = section.querySelector('[data-sa-column]')?.dataset.saColumn || 'full';
        const full = column === 'full', isLeft = column === 'left';
        const row = full ? Math.max(leftRow, rightRow) : isLeft ? leftRow : rightRow;
        section.style.gridColumn = full ? '1 / -1' : isLeft ? '1' : '2';
        section.style.gridRow = row + ' / span 1';
        const height = Math.max(1, Math.ceil(section.offsetHeight));
        section.style.gridRow = row + ' / span ' + height;
        if (full) leftRow = rightRow = row + height;
        else if (isLeft) leftRow = row + height;
        else rightRow = row + height;
      });
    }
    stepReview(carousel, step) {
      const slides = [...carousel.querySelectorAll('[data-review-slide]')];
      const index = Math.max(0, slides.findIndex(slide => !slide.hidden));
      this.showReview(carousel, (index + step + slides.length) % slides.length);
    }
    showReview(carousel, index) {
      const slides = [...carousel.querySelectorAll('[data-review-slide]')];
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      const selected = slides[index];
      if (selected?.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        selected.getAnimations().forEach(animation => animation.cancel());
        selected.animate([{opacity:0,transform:'translateX(5px)'},{opacity:1,transform:'translateX(0)'}],{duration:220,easing:'ease-out'});
      }
      this.schedule();
    }
    stepMedia(step) {
      const panels = [...this.root.querySelectorAll('[data-media-panel]')];
      if (panels.length < 2) return;
      const index = Math.max(0, panels.findIndex(panel => !panel.hidden));
      this.showMedia(panels[(index + step + panels.length) % panels.length].dataset.mediaPanel);
    }
    showThumbnails(start) {
      const buttons = [...this.root.querySelectorAll('[data-media-target]')];
      const count = window.innerWidth < 750 ? 5 : 8;
      const maximum = Math.max(0, buttons.length - count);
      const selected = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
      if (selected >= 0 && (selected < start || selected >= start + count)) start = Math.floor(selected / count) * count;
      this.thumbnailStart = Math.max(0, Math.min(maximum, start));
      buttons.forEach((button, index) => { button.hidden = index < this.thumbnailStart || index >= this.thumbnailStart + count; });
    }
    showMedia(id) {
      const selected = this.root.querySelector('[data-media-panel="' + id + '"]');
      if (!selected) return;
      const changed = selected.hidden;
      this.root.querySelectorAll('[data-media-panel]').forEach(panel => {
        panel.hidden = panel.dataset.mediaPanel !== String(id);
        if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
      });
      const buttons = [...this.root.querySelectorAll('[data-media-target]')];
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaTarget === String(id))));
      const index = buttons.findIndex(button => button.dataset.mediaTarget === String(id));
      const count = window.innerWidth < 750 ? 5 : 8;
      const start = index >= 0 && (index < this.thumbnailStart || index >= this.thumbnailStart + count) ? Math.floor(index / count) * count : this.thumbnailStart;
      this.showThumbnails(start);
      if (changed && selected.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        selected.getAnimations().forEach(animation => animation.cancel());
        selected.animate([{opacity:0,transform:'translateX(6px)'},{opacity:1,transform:'translateX(0)'}], {duration:240,easing:'ease-out'});
      }
      this.schedule();
    }
    update(notify) {
      if (!this.config) return;
      const root = this.root, config = this.config;
      const bundle = root.querySelector('sa-axis-bundle-offer');
      const options = bundle ? [] : [...root.querySelectorAll('[data-option]:checked')].sort((a,b) => Number(a.dataset.option) - Number(b.dataset.option)).map(input => input.value);
      const initial = root.querySelector('[data-variant-id]')?.value || new URL(window.location.href).searchParams.get('variant');
      const variant = options.length ? config.variants.find(v => v.options.length === options.length && v.options.every((value,index) => value === options[index])) : config.variants.find(v => String(v.id) === String(initial)) || config.variants[0];
      const s = config.strings;
      root.querySelectorAll('[data-price]').forEach(node => { node.innerHTML = variant ? variant.formattedPrice : s.unavailable; });
      const compare = variant && variant.compare_at_price > variant.price;
      root.querySelectorAll('[data-compare]').forEach(node => { node.hidden = !compare; node.innerHTML = compare ? variant.formattedCompare : ''; });
      root.querySelectorAll('[data-save]').forEach(node => { node.hidden = !compare; node.innerHTML = compare ? s.save + ' ' + variant.formattedSaving : ''; });
      root.querySelectorAll('[data-variant-id]').forEach(input => { input.value = variant?.id || ''; input.disabled = !variant; if (notify) input.dispatchEvent(new Event('change', {bubbles:true})); });
      root.querySelectorAll('[data-submit]').forEach(button => { button.disabled = !variant?.available; });
      root.querySelectorAll('[data-submit-label]').forEach(node => { node.textContent = !variant ? s.unavailable : variant.available ? s.cart : s.soldOut; });
      if (variant?.mediaId) this.showMedia(variant.mediaId);
      if (notify && variant) {
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
        root.dispatchEvent(new CustomEvent('variant:change', {bubbles:true,detail:{variant}}));
      }
      if (bundle?.initialized) bundle.sync();
      this.schedule();
    }
    destroy() {
      this.observer.disconnect();
      this.root.removeEventListener('shopify:block:select', this.blockselect);
      this.root.removeEventListener('click', this.click);
      this.root.removeEventListener('change', this.change);
      this.root.removeEventListener('keydown', this.keydown);
      this.root.removeEventListener('pointerdown', this.pointerdown);
      this.root.removeEventListener('pointerup', this.pointerup);
      this.root.removeEventListener('pointercancel', this.pointercancel);
    }
  }
  const refresh = () => {
    controllers.forEach((controller,root) => { if (!root.isConnected) { controller.destroy(); controllers.delete(root); } });
    document.querySelectorAll('.sap-sections').forEach(root => {
      if (controllers.has(root)) controllers.get(root).refresh();
      else controllers.set(root, new ProductSections(root));
    });
  };
  window.saProductSections = {refresh};
  window.addEventListener('resize', () => controllers.forEach(controller => controller.schedule()));
  ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(name => document.addEventListener(name, refresh));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
